import { createContext, Dispatch, SetStateAction } from 'react';

import { LogicalOperator } from '@models/FilterDefinition';
import { FilterGroup as FilterGroupType } from '@models/SearchFilter';

export type FilterDialogContextValues = {
  addRootLevelFilterGroup: VoidFunction;
  handleCombinatorChange: (logicalOperator: LogicalOperator) => void;
  handleRemoveFilter: (id: string) => () => void;
  hasRootLevelGroups: boolean;
  nestedFilterListChangeHandler: (
    filterFieldId: string
  ) => Dispatch<SetStateAction<FilterGroupType>>;
  searchFilter: FilterGroupType;
  setSearchFilter: Dispatch<SetStateAction<FilterGroupType>>;
};

const FilterDialogContext = createContext<FilterDialogContextValues>({
  addRootLevelFilterGroup: () => void 0,
  handleCombinatorChange: () => void 0,
  handleRemoveFilter: () => () => void 0,
  hasRootLevelGroups: false,
  nestedFilterListChangeHandler: () => () => void 0,
  searchFilter: {} as FilterGroupType,
  setSearchFilter: () => void 0,
});

export default FilterDialogContext;
